/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './clamp-text.stache';
import 'can/util/function/function';
import $clamp from 'clamp-js';
import DomEventsManager from 'scripts/dom-events-manager';
import striptags from 'striptags';

Component.extend({
    tag: 'clamp-text',
    template: template,
    viewModel: {
        define: {
            text: {
                get(text) {
                    if (text && typeof text === 'string') {
                        return striptags(text);
                    }
                    return '';
                }
            },
        },
        limit: 0,
        lines: 2,
        clampText($el, lines, limit) {
            let text = $el.get(0) && $el.get(0).innerText;

            // set to the limit
            if (text && limit && text.length > limit) {
                text = text.substring(0, limit) + '…';

                $el.html(text);
            }

            const {clamped, original} = $clamp($el.get(0), {clamp: lines, useNativeClamp: true});

            if (!clamped) {
                return;
            }

            let finalText = clamped.split(' ').slice(0, -1).join(' ') + '…';

            if (clamped.length === original.length) {
                finalText = original;
            }

            $el.html(finalText);
        }
    },
    helpers: {},
    events: {
        inserted() {
            DomEventsManager.subscribe(this);
        },
        onLayout(screen) {
            if (!this.element) {
                return;
            }
            setTimeout(() => {
                this.viewModel.clampText(this.element.find('.js-text'), this.viewModel.lines, this.viewModel.limit);
            }, 100)
        }
    }
});
